<p-dialog header="Change fleet ownership" [(visible)]="visible" (onHide)="close()" [modal]="true"
    [draggable]="false" [resizable]="false" [style]="{ width: 'min(980px, 94vw)' }"
    [breakpoints]="{ '860px': '96vw' }" styleClass="master-create-dialog ownership-transfer-modal">
    <section class="ownership-transfer-layout">
        <aside class="ownership-transfer-summary">
            <div class="ownership-transfer-summary__icon"><i class="pi pi-truck"></i></div>
            <div>
                <small>FLEET OPERATIONS</small>
                <h3>Review the resources</h3>
                <p>Move their operating company and classification without recreating the driver, vehicle, documents, or history.</p>
            </div>

            <div class="ownership-transfer-resources">
                <div *ngFor="let resource of resources" class="ownership-transfer-resource">
                    <span>{{ resource.resourceType === 'DRIVER' ? 'Driver' : 'Vehicle' }}</span>
                    <strong>{{ resource.label }}</strong>
                </div>
            </div>

            <label *ngIf="pairedResource" class="ownership-transfer-pair">
                <input type="checkbox" [(ngModel)]="includePairedResource" (ngModelChange)="onChange()">
                <span>Also transfer linked {{ pairedResource.resourceType === 'DRIVER' ? 'driver' : 'vehicle' }}:
                    <strong>{{ pairedResource.label }}</strong></span>
            </label>

            <div class="ownership-transfer-warning">
                <i class="pi pi-info-circle"></i>
                <span>Active deliveries are checked before confirmation. A resource with an active, uncompleted delivery cannot be changed.</span>
            </div>
        </aside>

        <div class="ownership-transfer-form">
            <div class="ownership-transfer-form__heading">
                <h3>Correction details</h3>
                <p>Choose the destination company and classification, then record why they need to change.</p>
            </div>

            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select inputId="ownershipDestination" [options]="destinationOptions" optionLabel="name"
                        optionValue="id" [(ngModel)]="targetCompanyId" (ngModelChange)="onDestinationChange()"
                        [loading]="loadingDestinations" [disabled]="loadingDestinations || !destinationOptions.length"
                        [filter]="true" filterBy="name" appendTo="body" styleClass="w-full"></p-select>
                    <label for="ownershipDestination">Destination company</label>
                </p-iftalabel>
            </p-inputGroup>
            <small *ngIf="destinationOptions.length === 1 && !loadingDestinations" class="ownership-transfer-hint">No permitted sister-company destinations are available.</small>
            <div *ngIf="destinationError" class="ownership-transfer-status ownership-transfer-status--error" role="alert">
                <i class="pi pi-exclamation-circle"></i><span>{{ destinationError }}</span>
            </div>

            <div class="ownership-transfer-type">
                <label id="ownershipTypeLabel">New ownership type</label>
                <p-selectButton [options]="ownershipOptions" optionLabel="label" optionValue="value"
                    [(ngModel)]="targetOwnershipType" (ngModelChange)="onChange()"
                    class="ownership-transfer-type__options" ariaLabelledBy="ownershipTypeLabel"></p-selectButton>
            </div>

            <p-inputGroup *ngIf="isRental">
                <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select inputId="ownershipRentalAgreement" [options]="rentalAgreements" optionLabel="agreementNumber"
                        optionValue="rentalAgreementId" [(ngModel)]="rentalAgreementId" (ngModelChange)="onChange()"
                        [filter]="true" filterBy="agreementNumber,supplierName" appendTo="body" styleClass="w-full"></p-select>
                    <label for="ownershipRentalAgreement">Active rental agreement</label>
                </p-iftalabel>
            </p-inputGroup>

            <p-inputGroup *ngIf="isTransporter">
                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select inputId="ownershipTransporter" [options]="transporterOptions" optionLabel="transporterName"
                        optionValue="crmClientId" [(ngModel)]="transporterCrmClientId" (ngModelChange)="onChange()"
                        [filter]="true" filterBy="transporterName,crmClientNumber,linkedCompanyName" appendTo="body" styleClass="w-full"></p-select>
                    <label for="ownershipTransporter">CRM transporter</label>
                </p-iftalabel>
            </p-inputGroup>

            <p-inputGroup class="ownership-transfer-reason">
                <p-inputGroupAddon><i class="pi pi-pencil"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <textarea pTextarea id="ownershipReason" rows="4" [(ngModel)]="reason" (ngModelChange)="onChange()"
                        class="w-full" maxlength="1000"></textarea>
                    <label for="ownershipReason">Reason for correction</label>
                </p-iftalabel>
            </p-inputGroup>

            <div *ngIf="eligibility" class="ownership-transfer-status ownership-transfer-status--success" role="status">
                <i class="pi pi-check-circle"></i>
                <span>Dispatch eligibility confirmed for {{ selectedResources.length }} resource{{ selectedResources.length === 1 ? '' : 's' }}. Review the destination and details, then confirm the change.</span>
            </div>
            <div *ngIf="errorMessage" class="ownership-transfer-status ownership-transfer-status--error" role="alert">
                <i class="pi pi-exclamation-circle"></i>
                <span>{{ errorMessage }}</span>
            </div>
        </div>
    </section>

    <ng-template pTemplate="footer">
        <div class="ownership-transfer-footer">
            <span>Eligibility is checked before the change is saved.</span>
            <div class="ownership-transfer-footer__actions">
                <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="close()"></p-button>
                <p-button *ngIf="!readyToConfirm" label="Check dispatch eligibility" icon="pi pi-shield"
                    [loading]="checking" [disabled]="saving || loadingDestinations || !selectedResources.length || !targetCompanyId" (onClick)="checkEligibility()"></p-button>
                <p-button *ngIf="readyToConfirm" label="Confirm ownership change" icon="pi pi-check"
                    [loading]="saving" (onClick)="submit()"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
